import request from '@/libs/https'

/* 上传图片 */
export function uploadImage(param) {
  return request({
    url: '/upload/multi',
    method: 'post',
    data: param
  })
}
/* 荣誉 */
export function honorList(param) {
    return request({
        url: '/Honour/list',
        method: 'get',
        params: param
    })
}

/* 轮播图 */
export function bannerList(param) {
    return request({
        url: '/banner/list',
        method: 'get',
        params: param
    })
}

/* 品牌客户 */
export function customer(param) {
    return request({
        url: '/BrandUser/list',
        method: 'get',
        params: param
    })
}

/* 获取新闻 */
export function getNews(param) {
    return request({
        url: '/News/list',
        method: 'get',
        params: param
    })
}

/* 客户案例 */
export function getCase(param) {
    return request({
        url: '/Case/list',
        method: 'get',
        params: param
    })
}
/* 新闻详情 */
export function getNewDetail(id) {
    return request({
        url: '/News/detail/' + id,
        method: 'get'
    })
}



// WEBPACK FOOTER //
// ./src/api/other.js